import styles from './index.module.less';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import {
  fetchInsMonitorDataInfo,
  fetchInsMonitorDataTimes,
  getMonitorInfoData,
  getStory_highlights,
} from '@/lib/service';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  InsMonitorInfoModel,
  InsMonitorModel,
  InsMonitorTimeModel,
  MonitorProfileModel,
  StoryDataRequest,
  StoryDataResponse,
} from '@/types/home';
import { Affix, App, Skeleton, Spin } from 'antd';
import { useTranslation } from 'next-i18next';
import { useConfigProvider } from '@/context/ConfigProvider';
import { useRouter } from 'next/router';
import { useUserProvider } from '@/context/UserProvider';
import { ReportEmpty, StoriesNoStartEmpty } from './ReportEmpty';
// import useScreenSize from '@/lib/hooks/utils/useScreenSize';
import dayjs from 'dayjs';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import { imgUrl } from '@/shared/utils';
// import UnlockModalContent from '../Common/UnlockModalContent';
import ActiveAccountModal from '../ActiveAccountModal';
import { useWindowSize } from 'react-use';
import Image from 'next/image';
import { getInsStoryDownload } from '@/lib/service/dashboard';
import ReportDisclaimers from './ReportDisclaimers';

const EmptyPage = dynamic(() => import('../Common/Empty'), {
  ssr: false,
});
const TiesTrailsContent = dynamic(() => import('./TiesTrailsContent'), {
  ssr: false,
});
const AIInsightsContent = dynamic(() => import('./AIInsightsContent'), {
  ssr: false,
});
const SuspiciousAccountsContent = dynamic(() => import('./SuspiciousAccountsContent'), {
  ssr: false,
});
const PostsPublishedContent = dynamic(() => import('./PostsPublishedContent'), {
  ssr: false,
});
const MostCommentsContent = dynamic(() => import('./MostCommentsContent'), {
  ssr: false,
});
const NeedUpgradeContent = dynamic(() => import('./NeedUpgradeContent'), {
  ssr: false,
});
const CardItem = dynamic(() => import('../Common/CardItem'), {
  ssr: false,
});
const ReportActiveContent = dynamic(() => import('./ReportActive'), {
  ssr: false,
});
const ReportLikesContent = dynamic(() => import('./ReportLikes'), {
  ssr: false,
});
const ReportFollowContent = dynamic(() => import('./ReportFollowContent'), {
  ssr: false,
});
const ReportTagsCloud = dynamic(() => import('./ReportTagsCloud'), {
  ssr: false,
});
const ReportDownloadContent = dynamic(() => import('./ReportDownload'), {
  ssr: false,
});
const ReportDateContent = dynamic(() => import('./ReportDate'), {
  ssr: false,
});
const StoriesListContent = dynamic(
  () => import('../view-instagram-anonymously/SearchResultContent/StoriesListContent'),
  {
    ssr: false,
  }
);
const HighlightsContent = dynamic(() => import('../view-instagram-anonymously/SearchResultContent/HighlightsContent'), {
  ssr: false,
});
const EmptyLoadingContent = dynamic(() => import('./EmptyLoadingContent'), {
  ssr: false,
});

const ReportContent = ({ data }: { data: any }) => {
  const id = data['id'];

  const { t } = useTranslation('common');
  const { message } = App.useApp();
  const [timeList, setTimeList] = useState<[InsMonitorTimeModel]>();
  const [currentIndex, setCurrentIndex] = useState<number>();
  const [currentTime, setCurrentTime] = useState<InsMonitorTimeModel>();
  const [userModel, setUserModel] = useState<InsMonitorModel>();
  const [infoModel, setInfoModel] = useState<InsMonitorInfoModel>();
  const { isBlogWeb } = useConfigProvider();
  const { isLogin } = useUserProvider();
  const router = useRouter();
  const { lastDate, isDemo, data_id, dataType = '0' } = router.query;
  const [currentDataType, setCurrentDataType] = useState(dataType);
  const [storyData, setStoryData] = useState<StoryDataResponse>();
  const [profileModel, setProfileModel] = useState<MonitorProfileModel>(null);
  const [openUnlock, setOpenUnlock] = useState<boolean>(false);

  const loadingStory = useRef(false);

  const [timeLoading, setTimeLoading] = useState<boolean>(false);
  const [dataLoading, setDataLoading] = useState<boolean>(false);
  const [downloadLoading, setDownloadLoading] = useState<boolean>(false);

  const { width } = useWindowSize();

  const onDownloadClick = () => {
    if (downloadLoading) {
      return;
    }
    setDownloadLoading(false);

    getInsStoryDownload(userModel?.media_name, 'batch', '')
      .then((res) => {
        if (res?.code === 0) {
          window.location.href = res.data;
        } else {
          message.error(res?.message);

          if (res?.code === 22010 || res?.code === 22011) {
          }
        }
      })
      .finally(() => {
        setDownloadLoading(false);
      });
  };

  const categoryList = useMemo(
    () => [
      {
        icon: '/images/report/report-Activity-Analytics-icon.webp',
        iconSelect: '/images/report/report-Activity-Analytics-icon-select.webp',
        title: t('ActivityAnalytics'),
      },
      {
        icon: '/images/report/report-Ties&Trails-icon.webp',
        iconSelect: '/images/report/report-Ties&Trails-icon-select.webp',
        title: t('Ties & Trails'),
      },
      {
        icon: '/images/report/report-Stories&Highlights-icon.webp',
        iconSelect: '/images/report/report-Stories&Highlights-icon-select.webp',
        title: t('Stories & Highlights'),
      },
      {
        icon: '/images/report/report-AI-Insights-icon.webp',
        iconSelect: '/images/report/report-AI-Insights-icon-select.webp',
        title: t('AI Insights'),
      },
    ],
    []
  );

  const getStoryHightliData = async (param: StoryDataRequest) => {
    if (param?.report_id === null || param?.report_id === undefined) {
      return;
    }
    try {
      const res = await getStory_highlights(param, router?.locale);

      setStoryData(res?.data);
      loadingStory.current = false;
    } catch (error) {
    } finally {
      loadingStory.current = false;
    }
  };

  useEffect(() => {
    if (isBlogWeb) {
      router.push('/instagram-tracking-blog');
    }
  }, []);

  useEffect(() => {
    loadingStory.current = true;
    getStoryHightliData({
      report_id: currentTime?.report_id,
      begin_date: currentTime?.begin_time.split(' ')?.[0],
      end_date: currentTime?.end_time.split(' ')?.[0],
    });
  }, [currentTime]);

  const onUpgradeAction = (subs_id: any, item_id: any, monitor_id: any) => {
    if (isDemo === 'true') {
      return;
    }
    if (subs_id) {
      router.push(`/plan?last_subs_id=${subs_id}&last_item_id=${item_id}&monitor_id=${monitor_id}&type=1`);
    }
  };

  const replaceURLParameter = (param: string, value: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set(param, value);
    return url.pathname + url.search;
  };

  const changeCurrentTimeData = (timeModel?: InsMonitorTimeModel) => {
    if (timeModel?.report_id !== currentTime?.report_id) {
      setCurrentTime(timeModel);
    }
  };

  const fetchMonitorInfo = useCallback(() => {
    if (!!profileModel) {
      return;
    }

    getMonitorInfoData(id)
      .then((res) => {
        if (res?.code === 0) {
          setProfileModel(res?.data);
          setUserModel((prev) => ({
            ...prev,
            media_name: res?.data?.media_name,
            avatar: res?.data?.profile_pic_url,
          }));
          setInfoModel((prev) => ({ ...(prev ?? {}), media_info: { ...res?.data } }));
        } else {
          message.error(res.message);
        }
      })
      .catch((error) => {
        message.error(error.message);
      });
  }, [profileModel, id, message]);

  const loadData = () => {
    if (timeList?.length > 0) {
      return;
    }

    setTimeLoading(true);

    fetchInsMonitorDataTimes(id, data['locale'])
      .then((items) => {
        setTimeLoading(false);

        if (items?.code === 40001) {
          router.push('/');
          return;
        }

        if (items?.code != 0) {
          message.error(items?.message);
          return;
        }

        setTimeList([...items?.data]);
        var tempIndex: number;
        var tempNoDataIndex: number;
        var tempCurrnetDataIndex: number;
        var dataIdIndex: number;

        (items?.data ?? []).map((item, index) => {
          if (data_id !== null && data_id !== undefined && item?.data_id === data_id) {
            dataIdIndex = index;
          }
          if (item?.has_data) {
            tempIndex = index;
          }
          const startTime = dayjs(item?.begin_time);
          const endTime = dayjs(item?.end_time);

          if (lastDate !== undefined) {
            const isInRange =
              dayjs(`${lastDate}`).isAfter(startTime) &&
              dayjs(`${lastDate}`).isBefore(endTime) &&
              !item?.end_time?.includes(`${lastDate}`);
            if (isInRange || item?.begin_time?.includes(`${lastDate}`)) {
              tempNoDataIndex = index;
            }
          }

          if (tempCurrnetDataIndex === undefined) {
            const isInRange = dayjs().isAfter(startTime) && dayjs(`${lastDate}`).isBefore(endTime);
            if (isInRange) {
              tempCurrnetDataIndex = index;
            }
          }
        });

        if (dataIdIndex !== undefined) {
          setCurrentIndex(dataIdIndex);
          changeCurrentTimeData(items?.data[dataIdIndex]);
        } else {
          if (tempNoDataIndex != undefined) {
            if (items?.data?.length > tempNoDataIndex) {
              setCurrentIndex(tempNoDataIndex);
              changeCurrentTimeData(items?.data[tempNoDataIndex]);
            }
          } else if (tempIndex != undefined) {
            if (items?.data?.length > tempIndex) {
              setCurrentIndex(tempIndex);
              changeCurrentTimeData(items?.data[tempIndex]);
            }
          } else if (tempCurrnetDataIndex != undefined) {
            if (items?.data?.length > tempCurrnetDataIndex) {
              setCurrentIndex(tempCurrnetDataIndex);
              changeCurrentTimeData(items?.data[tempCurrnetDataIndex]);
            }
          } else {
            if (items?.data?.length > 0) {
              setCurrentIndex(0);
              changeCurrentTimeData(items?.data[0]);
            } else {
              setCurrentIndex(undefined);
              changeCurrentTimeData(undefined);
            }
          }
        }
      })
      .catch((error) => {
        setTimeLoading(false);
        message.error(error.message);
      });
  };

  const loadDataInfo = useCallback(() => {
    setDataLoading(true);
    fetchInsMonitorDataInfo(id, currentTime?.end_time, currentTime?.data_id, data['locale'])
      .then((res) => {
        if (res.code == 0) {
          setInfoModel((prev) => ({
            ...(prev ?? {}),
            ...res?.data,
            // 确保 media_info 不会被覆盖为 undefined/null
            media_info: res?.data?.media_info ?? prev?.media_info,
          }));
          setUserModel((prev) => ({
            ...prev,
            // media_name: res?.data?.media_info?.media_name,
            // avatar: res?.data?.media_info?.profile_pic_url,
            media_url: res?.data?.media_url,
            like_num: res?.data?.like_num,
            like_pic_num: res?.data?.like_pic_num,
            like_video_num: res?.data?.like_video_num,
            like_acct_num: res?.data?.like_acct_num,
            like_acct_verify_num: res?.data?.like_acct_verify_num,
            following_num: res?.data?.following_num,
            un_follow_num: res?.data?.un_follow_num,
            active_begin_time: res?.data?.active_begin_time,
            active_end_time: res?.data?.active_end_time,
            tracking_date: res?.data?.tracking_date,
            next_tracking_date: res?.data?.next_tracking_date,
            profile: res?.data?.media_info?.profile,
            post_report_date: res?.data?.post_report_date,
            next_report_begin: res?.data?.next_report_begin,
            next_report_end: res?.data?.next_report_end,
            next_report_show: res?.data?.next_report_show,
            data_type: res?.data?.data_type,
          }));
        } else {
          message.error(res?.message);
        }
        setDataLoading(false);
      })
      .catch((error) => {
        message.error(error.message);
        setDataLoading(false);
      });
  }, [id, currentTime?.end_time, currentTime?.data_id, data, message]);

  const hasSocialData = () => {
    return (
      infoModel?.social_platforms?.snapchat?.length > 0 ||
      infoModel?.social_platforms?.twitter?.length > 0 ||
      infoModel?.social_platforms?.tiktok?.length > 0 ||
      infoModel?.social_platforms?.pinterest?.length > 0 ||
      infoModel?.social_platforms?.linkedin?.length > 0
    );
  };

  useEffect(() => {
    if (!!data) {
      loadData();
      fetchMonitorInfo();
    }
  }, [data]);

  useEffect(() => {
    if (currentTime?.end_time != undefined && currentTime?.has_data) {
      loadDataInfo();
    } else {
      // setInfoModel(undefined);
    }
    // if (!currentTime?.data_id) {
    //   setCurrentDataType('3');
    // } else {
    //   setCurrentDataType('1');
    // }
  }, [currentTime, loadDataInfo]);

  const getTopContent = useMemo(() => {
    return (
      <div className={styles.topContainer}>
        <div className={styles.backBtn} onClick={() => router.back()}>
          {`< ${t('Back')}`}
        </div>
        {width > 915 && <h1>{t('Activity Report')}</h1>}

        {userModel && (
          <div className={styles.userContent}>
            <div className={styles.avatar}>
              <img src={imgUrl(profileModel?.profile_pic_url)} alt="avatar" loading="lazy" />
            </div>
            <div className={styles.userDetails}>
              <div className={styles.username}>
                <span>{profileModel?.media_name}</span>
                {profileModel?.task_num > 0 && (
                  <span
                    style={{
                      padding: '1px 3px',
                      borderRadius: '3px',
                      background: '#725CFF',
                      color: '#fff',
                      fontSize: '14px',
                    }}
                  >
                    {`${profileModel?.task_num} ${t('reports delivered')}`}
                  </span>
                )}
              </div>
              <div className={styles.followData}>
                {profileModel?.follower_num && <span>{`${t('Followers')}: ${profileModel?.follower_num}`}</span>}
                {profileModel?.post_num && <span>{`${t('Posts')}: ${profileModel?.post_num}`}</span>}
                {profileModel?.following_num && <span>{`${t('Following')}: ${profileModel?.following_num}`}</span>}
              </div>
              <div className={styles.userDesc}>{profileModel?.profile}</div>
            </div>
          </div>
        )}

        <div style={{ display: !infoModel && timeLoading ? 'block' : 'none' }}>
          <Skeleton active title={false} paragraph={{ rows: 20, width: '100%' }} style={{ marginTop: '50px' }} />
        </div>
      </div>
    );
  }, [width, profileModel, timeLoading, infoModel]);

  const isEmpty =
    !timeLoading && (timeList === undefined || currentTime?.has_data === false || currentTime?.private_mark !== 0);

  const getTiesTrailsContent = useMemo(() => {
    return (
      <div
        style={{
          display: currentDataType === '1' ? 'block' : 'none',
        }}
      >
        <TiesTrailsContent identification={id} monitorModel={infoModel} profileModel={profileModel} />
      </div>
    );
  }, [currentDataType, infoModel, id, profileModel]);

  const getStateVal = useMemo(() => {
    return (
      infoModel?.can_upgrade &&
      infoModel?.item_id !== 2 &&
      infoModel?.item_id !== 3 &&
      infoModel?.item_id !== 6 &&
      infoModel?.item_id !== 7
    );
  }, [infoModel?.can_upgrade, infoModel?.item_id]);

  if (isBlogWeb) {
    return <></>;
  }

  return (
    <CommonBackContent>
      <div className={styles.content}>
        {getTopContent}

        <Affix offsetTop={!isLogin && width > 900 ? 108 : 64}>
          {!timeLoading && (
            <div className={styles.changeTypeDiv}>
              {categoryList.map((item, index) => {
                return (
                  <div
                    key={item?.title}
                    className={classNames(styles.btnContainer, currentDataType === `${index}` ? styles.active : '')}
                    onClick={() => {
                      const newUrl = replaceURLParameter('dataType', `${index}`);
                      window.history.replaceState({}, '', newUrl);
                      setCurrentDataType(`${index}`);
                    }}
                  >
                    <img
                      src={currentDataType === `${index}` ? item?.iconSelect : item?.icon}
                      alt={item?.title}
                      width={18}
                      height={18}
                    />
                    <span>{item?.title}</span>
                  </div>
                );
              })}
            </div>
          )}
        </Affix>

        {timeList?.length > 0 && currentDataType !== '1' && (
          <div style={{ marginBottom: '30px' }}>
            <ReportDateContent
              currentIndex={currentIndex}
              data={timeList}
              onClick={(index) => {
                if (timeList?.length > index) {
                  setCurrentIndex(index);
                  changeCurrentTimeData(timeList[index]);
                }
              }}
            />
          </div>
        )}

        {timeList?.length > 0 ? (
          <Spin spinning={!infoModel && dataLoading}>
            <div className={classNames([styles.dataContainer, currentDataType === '1' ? styles.dataContainer0 : ''])}>
              {getTiesTrailsContent}

              {currentDataType === '0' && (
                <>
                  {isEmpty ? (
                    currentTime?.old_data ? (
                      <ReportEmpty data={currentTime} />
                    ) : (
                      <EmptyLoadingContent
                        currentTime={currentTime}
                        identification={id}
                        mediaName={infoModel?.media_info?.media_name}
                        onUpgradeClick={() => setOpenUnlock(true)}
                      />
                    )
                  ) : (
                    <div
                    // style={{
                    //   display: currentDataType === '0' && infoModel !== undefined ? 'block' : 'none',
                    // }}
                    >
                      <CardItem data={userModel} isReport={true} />
                      {/*
                  <EmptyLoadingContent
                  currentTime={currentTime}
                  identification={id}
                  mediaName={infoModel?.media_info?.media_name}
                  onUpgradeClick={() => setOpenUnlock(true)}
                /> */}
                      <ReportActiveContent data={infoModel} />

                      {hasSocialData() && (
                        <SuspiciousAccountsContent
                          title={t('Suspicious Accounts')}
                          tip={t(
                            "The Suspicious Accounts feature is powered by DolphinRadar's data analysis, offering insights based on available information. While indicative, 100% accuracy cannot be guaranteed."
                          )}
                          data={infoModel?.social_platforms}
                        />
                      )}

                      {infoModel?.post_list?.length > 0 && <PostsPublishedContent data={infoModel?.post_list} />}
                      {infoModel?.comment_ranks?.length > 0 && <MostCommentsContent data={infoModel?.comment_ranks} />}

                      <ReportLikesContent data={infoModel} />

                      <ReportFollowContent
                        key={'new_followings'}
                        val={`${infoModel?.new_followings?.length ?? 0}`}
                        title={t('NewFollowings')}
                        imgPath={'/images/report/new-followings.webp'}
                        data={infoModel?.new_followings || []}
                      />

                      <ReportFollowContent
                        key={'un_follows'}
                        val={infoModel?.un_follow_num}
                        title={t('Unfollows')}
                        imgPath={'/images/report/unfollows.webp'}
                        data={infoModel?.un_follows || []}
                      />

                      <ReportFollowContent
                        key={'tagged_users'}
                        val={`${infoModel?.tagged_users?.length ?? 0}`}
                        title={t('RecentlyTaggedUsers')}
                        // imgPath={'/images/report/unfollows.webp'}
                        data={infoModel?.tagged_users || []}
                      />

                      <ReportTagsCloud title={t('LikedMediaTagsCloud')} canClick={true} data={infoModel?.like_tags} />

                      <ReportTagsCloud title={t('UserInterests')} data={infoModel?.following_tags} />

                      {!hasSocialData() && getStateVal && (
                        <NeedUpgradeContent
                          title={t('Suspicious Accounts')}
                          imagePath="/images/report/report-media-icon.webp"
                          tip={t(
                            'Identify potential suspicious accounts linked to your tracked Instagram profile across Twitter, LinkedIn, Pinterest, TikTok, and Snapchat.'
                          )}
                          onClick={() => onUpgradeAction(infoModel?.subs_id, infoModel?.item_id, infoModel?.monitor_id)}
                        />
                      )}

                      {(infoModel?.post_list?.length ?? 0) === 0 && getStateVal && (
                        <NeedUpgradeContent
                          title={`** ${t('Posts Were Published')}`}
                          imagePath="/images/report/report-publish-icon.webp"
                          tip={t(
                            'See all posts and the most frequent commenters on your tracked Instagram account during your subscription period.'
                          )}
                          onClick={() => onUpgradeAction(infoModel?.subs_id, infoModel?.item_id, infoModel?.monitor_id)}
                        />
                      )}

                      {(infoModel?.comment_ranks?.length ?? 0) === 0 && getStateVal && (
                        <NeedUpgradeContent
                          title={t('Top 1xxx1 Accounts With Most Comments').replace('1xxx1', `**`)}
                          imagePath="/images/report/report-comments-icon.webp"
                          tip={t(
                            'See all posts and the most frequent commenters on your tracked Instagram account during your subscription period.'
                          )}
                          onClick={() => onUpgradeAction(infoModel?.subs_id, infoModel?.item_id, infoModel?.monitor_id)}
                        />
                      )}

                      <ReportDownloadContent data={infoModel?.download_url} />
                    </div>
                  )}
                </>
              )}

              {currentDataType === '3' && (
                <div>
                  <AIInsightsContent
                    identification={id}
                    infoModel={infoModel}
                    currentTime={currentTime}
                    profileModel={profileModel}
                  />
                </div>
              )}

              <div
                style={{
                  display: currentDataType === '2' ? 'block' : 'none',
                }}
              >
                <Spin spinning={loadingStory.current}>
                  <div className={styles.storiesContent}>
                    {storyData?.not_start ? (
                      <>
                        <StoriesNoStartEmpty />
                      </>
                    ) : (
                      <>
                        <>
                          {storyData?.need_upgrade && (
                            <div className={styles.title}>
                              <h3>{t('Stories & Highlights')}</h3>
                            </div>
                          )}
                        </>

                        <div className={styles.main}>
                          {userModel?.data_type === 'MONTH' ||
                          userModel?.data_type === 'WEEK' ||
                          storyData?.need_upgrade ? (
                            <div className={styles.imgContainer}>
                              <img alt="" src={'/images/report/stories-lock.webp'} />
                              <div className={styles.linkBtn}>
                                <div>
                                  <span
                                    onClick={() =>
                                      onUpgradeAction(storyData?.subs_id, storyData?.item_id, storyData?.monitor_id)
                                    }
                                    className={styles.link}
                                  >
                                    {t('Upgrade')}
                                  </span>{' '}
                                  {t('to a quarterly or annual plan to access Stories and Highlights.')}
                                </div>
                                <div
                                  onClick={() =>
                                    onUpgradeAction(storyData?.subs_id, storyData?.item_id, storyData?.monitor_id)
                                  }
                                  className={styles.link}
                                >
                                  {t('Updates begin the day you upgrade.')}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className={styles.storyData}>
                              <div className={styles.storyDataTitle}>
                                <span>{t('Stories & Highlights update daily for you to enjoy.')}</span>

                                <button className={styles.batchDownload} onClick={onDownloadClick}>
                                  <Image src="/images/landingpage/download_icon_2.webp" alt="" width={16} height={16} />
                                  {width > 768 && <span>{t('Batch Download')}</span>}
                                </button>
                              </div>
                              <StoriesListContent title={t('New Stories')} isReport data={storyData?.stories} />
                              <HighlightsContent
                                data={storyData?.new_highlights}
                                isNew
                                isReport
                                title={t('New Highlights')}
                              />
                              <HighlightsContent
                                data={storyData?.old_highlights}
                                isReport
                                title={t('Past Highlights')}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </Spin>
              </div>
            </div>
          </Spin>
        ) : (
          <>{!timeLoading && !dataLoading && <EmptyPage />}</>
        )}

        <ReportDisclaimers />
      </div>

      {openUnlock && (
        <ActiveAccountModal
          isModalOpen={openUnlock}
          routerInfo={{
            identification: id,
            avatar: profileModel?.profile_pic_url,
            name: profileModel?.media_name,
          }}
          closeFn={() => {
            setOpenUnlock(false);
          }}
        />
      )}
    </CommonBackContent>
  );
};

export default ReportContent;
